module.exports = __webpack_public_path__ + "media/Major Lazer - Particula (feat. Nasty C, Ice Prince, Patoranking & Jidenna).15a41170.mp3";